export class UpdatePasswordVM {
    password: string;
    confirmPassword: string;
    email: string;
    token: string;
}
